import {
  allocateCarriers,
  audioBandCarrierCapacity,
  FORWARD_AUDIO_BAND,
  FULL_AUDIO_BAND,
  RETURN_AUDIO_BAND,
  type AudioCarrierPlan,
} from '@spectrabus/audio-modem';

/**
 * The acquisition profiles deliberately assume only moderate SNR. They are
 * deterministic interoperability floors, not measurements of the room; both
 * peers must derive the identical plan without negotiation.
 */
const FLAT_PROFILE_SNR_DB = 17;

function flatSnrProfile(carrierCount: number): readonly number[] {
  return Array.from({ length: carrierCount }, () => FLAT_PROFILE_SNR_DB);
}

/** Historical single-direction plan spanning the whole audible allocation. */
export function createFallbackAudioPlan(sampleRate: number): AudioCarrierPlan {
  return allocateCarriers(
    flatSnrProfile(audioBandCarrierCapacity(FULL_AUDIO_BAND)),
    sampleRate,
    'simulated',
    FULL_AUDIO_BAND,
  );
}

/** Sender-to-receiver data band under frequency-division duplex. */
export function createForwardAudioPlan(sampleRate: number): AudioCarrierPlan {
  return allocateCarriers(
    flatSnrProfile(audioBandCarrierCapacity(FORWARD_AUDIO_BAND)),
    sampleRate,
    'simulated',
    FORWARD_AUDIO_BAND,
  );
}

/** Receiver-to-sender feedback band under frequency-division duplex. */
export function createReturnAudioPlan(sampleRate: number): AudioCarrierPlan {
  return allocateCarriers(
    flatSnrProfile(audioBandCarrierCapacity(RETURN_AUDIO_BAND)),
    sampleRate,
    'simulated',
    RETURN_AUDIO_BAND,
  );
}
